export const sleep = (timeout) =>
  new Promise((resolve) => {
    setTimeout(() => resolve(undefined), timeout);
  });
